import React from 'react';

export default function HupalupaMayis2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA STORE — ₺400,000 — Mayıs 2026                                */}
      {/* Google Ads + Meta Ads (Remarketing bütçesi Google + Meta'ya dağıtıldı)*/}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Mayıs 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + PMAX + Shopping + YouTube) • Meta Ads (Sales + Traffic + Video)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Mayıs 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺400,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺155,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">38.75% • Search + PMAX + Shopping + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺245,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">61.25% • Sales + Catalog + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺13,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">96.8K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 35.0K + Meta 61.8K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Meta Sales Focus</span>
              <p className="text-xl font-bold text-emerald-800">₺212K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">50.5K tahmini conversion click</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA STORE Mayıs 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">11,600</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺58,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Performance Max</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">12,222</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺55,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Shopping</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">9,667</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺29,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">108,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.12 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺13,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">33,489</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺155,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Sales (Advantage+ & Catalog)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">50,476</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.2</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺212,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">11,200</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺28,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">62,500 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.08 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺5,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">61,676</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺4.0</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺245,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">95,165</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺400,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Remarketing kalemi plandan çıkarılmış; ilgili bütçe Google Ads ve Meta Ads kanallarına oransal olarak dağıtılmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                  Store odaklı kampanyalar e-ticaret dönüşümü ve ürün satışı hedeflidir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA — ₺200,000 — Mayıs 2026                                      */}
      {/* Google Ads + Meta Ads + TikTok Ads                                    */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-1.5">
              <img src="https://hupalupa.com.tr/images/logo_s.png" alt="Hupalupa" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA — Mayıs 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + GDN + YouTube) • Meta Ads (Engagement + Reach + Traffic + Video) • TikTok Ads</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Mayıs 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺200,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺115,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">57.5% • Search + GDN + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺70,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">35% • Engagement + Reach + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺15,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">7.5% • Video + Traffic</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺38,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">30.7K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 16.3K + Meta 12K + TikTok 2.3K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Total Reach</span>
              <p className="text-xl font-bold text-emerald-800">840K</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Across all channels (May)</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA Mayıs 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">14,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺70,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">GDN (Display)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">2,333</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">253,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.15 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺38,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">16,333</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺115,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Engagement</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">6,667</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Reach & Frequency</td>
                    <td className="px-4 py-3 text-sm text-right">1,200,000</td>
                    <td className="px-4 py-3 text-sm text-right">840,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺15.0</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺18,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">5,357</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.8</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">70,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.10 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">1,200,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">840,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">12,024</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺4.0</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺70,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={2}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">In-Feed Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">133,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.06 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">2,333</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold">
                    <td className="px-4 py-3 text-sm text-gray-800">TikTok Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">2,333</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">₺15,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">1,200,000</td>
                    <td className="px-4 py-3 text-sm text-right">840,000</td>
                    <td className="px-4 py-3 text-sm text-right">30,690</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺200,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
